import { Constants } from './Constants';

export function getSkipOnboardingInfo(pageAttrs?: { skipOnboardingOnSignup?: boolean } | null) {
    if (pageAttrs?.skipOnboardingOnSignup === true) {
        return { [Constants.Track.KEY_LANADING_PAGE_SKIP_ONBOARDING]: 'true' };
    }
    if (pageAttrs?.skipOnboardingOnSignup === false) {
        return { [Constants.Track.KEY_LANADING_PAGE_SKIP_ONBOARDING]: 'false' };
    }
    return undefined;
}

export function getSkipOnboardingFromLocalStorage() {
    try {
        const val = localStorage.getItem(Constants.Track.KEY_LANADING_PAGE_SKIP_ONBOARDING) || undefined;
        if (val !== undefined && val !== undefined) {
            return val === 'true';
        }
        // eslint-disable-next-line no-empty
    } catch (error) {
    }
    return false;
}

export function setTempSkipOnboarding() {
    try {
        sessionStorage.setItem(Constants.Track.KEY_LANADING_PAGE_SKIP_ONBOARDING, 'true');
        // eslint-disable-next-line no-empty
    } catch (error) {
    }
}

/**
 * Drop the session flag. Needed because the flag lives in sessionStorage for the
 * whole tab: without a way to clear it, one surface that opted out of onboarding
 * keeps it suppressed for every later sign-up in that tab, and a surface that
 * opts back IN has no way to say so.
 */
export function clearTempSkipOnboarding() {
    try {
        sessionStorage.removeItem(Constants.Track.KEY_LANADING_PAGE_SKIP_ONBOARDING);
        // eslint-disable-next-line no-empty
    } catch (error) {
    }
}

export function getTempSkipOnboarding() {
    try {
        const val = sessionStorage.getItem(Constants.Track.KEY_LANADING_PAGE_SKIP_ONBOARDING) || undefined;
        if (val !== undefined && val !== undefined) {
            return val === 'true';
        }
        // eslint-disable-next-line no-empty
    } catch (error) {
    }
    return false;
}
